export default __webpack_public_path__ + "css/SalesOrderDetails.bundle.css";